document.documentElement.classList.remove('no-js');
document.addEventListener('change',function(event){
  if(event.target.matches('[data-sort-by]')){
    const url=new URL(window.location.href);url.searchParams.set('sort_by',event.target.value);window.location=url.toString();
  }
  if(event.target.matches('[data-variant-select]')){
    const option=event.target.selectedOptions[0];
    const price=document.querySelector('[data-current-price]');
    const compare=document.querySelector('[data-compare-price]');
    const add=document.querySelector('[data-add-button]');
    if(price) price.textContent=option.dataset.priceText;
    if(compare){compare.textContent=option.dataset.compareText||'';compare.hidden=!option.dataset.compareText;}
    if(add){const available=option.dataset.available==='true';add.disabled=!available;add.textContent=available?'Add to bag':'Sold out';}
  }
});